import { Icon, Row, Col } from "@/base/index";
import FacebookSvg from "../../static/footer-contacts-facebook.svg?react";
import InstagramSvg from "../../static/footer-contacts-instagram.svg?react";
import LinkedinSvg from "../../static/footer-contacts-linkedin.svg?react";
import TwitterSvg from "../../static/footer-contacts-twitter.svg?react";
import YoutubeSvg from "../../static/footer-contacts-youtube.svg?react";

const webSocialItems = [
  {
    icon: LinkedinSvg,
    href: "https://www.linkedin.com/company/petrosoft-llc/",
    label: "LinkedIn",
  },
  {
    icon: FacebookSvg,
    href: "https://www.facebook.com/PetrosoftLLC",
    label: "Facebook",
  },
  {
    icon: TwitterSvg,
    href: "https://twitter.com/petrosoft_inc",
    label: "Twitter",
  },
  {
    icon: YoutubeSvg,
    href: "https://www.youtube.com/petrosoftus",
    label: "YouTube",
  },
  {
    icon: InstagramSvg,
    href: "https://www.instagram.com/petrosoftinc/",
    label: "Instagram",
  },
];

export const FooterContactsWebSocial = () => {
  return (
    <Row gutter={[16, 12]}>
      {webSocialItems.map((item, key) => (
        <Col key={key} xs={{ flex: "1 1 50px" }} lg={{ flex: "none" }}>
          <a
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.label}
          >
            <Icon size={48} component={item.icon} />
          </a>
        </Col>
      ))}
    </Row>
  );
};
